// Module
var code = "<md-input-container class=\"md-block\" flex>\n    <label>{{'EMPLOYEES.ADD.INPUT_KEYWORD' | translate}}</label>\n    <input ng-model=\"$ctrl.keyword\" ng-change=\"$ctrl.onChange()\" ng-model-options=\"$ctrl.options\" ng-keydown=\"$ctrl.alphaNumericOnly($event) ? $event:$event.preventDefault()\">\n</md-input-container>\n";
// Exports
module.exports = code;